
export enum TemplateModeEnum {
  Edit,
  Clone
}
